import { api } from "../common/utils"

const CANCEL_REQUEST_ENDPOINT = "/api/v1/cancel-request"

export interface CancelRequestPayload {
  reason: string
}

export interface CancellationRequest {
  org_id: string
  loid: string
  timestamp: string
}

export interface GetCancelRequestResponse {
  status: string
  cancellation_request: CancellationRequest | null
}

const cancelRequest = {
  get: async (): Promise<GetCancelRequestResponse> => {
    const { data } = await api.get(CANCEL_REQUEST_ENDPOINT)
    return data
  },
  submit: async (payload: CancelRequestPayload) => {
    const { data } = await api.post(CANCEL_REQUEST_ENDPOINT, payload)
    return data
  },
  clear: async () => {
    const { data } = await api.delete(CANCEL_REQUEST_ENDPOINT)
    return data
  }
}

export default cancelRequest
